import {
  COLOR_ABSENT,
  COLOR_PRESENT,
  COLOR_TARDY,
} from "redux/constants";

export default theme => ({
  dialogTitleRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  dialogTitleCloseButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  dialogContentRoot:{
    minWidth:500,
    paddingBottom:0,
    paddingTop:0,
  },
  formControlLabel: {
    margin: theme.spacing.unit,
    marginLeft:0,
    minWidth: 120,
  },
  gridItem: {
    padding:'2px'
  },
  textField: {
    marginBottom:0
  },
  paGridItem: {
    marginBottom: 8,
    marginTop: 10,
  },
  paToggleContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
  },
  paTogglePill: {
    position: 'relative',
    width: 72,
    height: 28,
    borderRadius: 14,
    flexShrink: 0,
    transition: 'background 0.2s',
  },
  paToggleLabel: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.05em',
    color: 'white',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  paToggleThumb: {
    position: 'absolute',
    top: 3,
    width: 22,
    height: 22,
    borderRadius: '50%',
    background: 'white',
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    transition: 'left 0.2s',
  },
  paToggleText: {
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '0.08em',
    opacity: 0.6,
  },
  sectionLabel: {
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '0.08em',
    opacity: 0.6,
    marginTop: 10
  },
  sectionDivider: {
    marginTop: 6,
    marginBottom: 12,
  },
  sectionHeader: {
    marginTop: 24,
  },
  svgContainer: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '800px',
  },
  logicToggleText: {
    margin: '0px',
    marginLeft: '0px',
    fontSize: '16px',
  },
  logicToggleTextFlex: {
    margin: '0px',
    marginLeft: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  infoIcon: {
    marginLeft: '8px',
    fontSize: '20px',
    color: '#666',
  },
  summaryLogicText: {
    margin: '0px',
    fontSize: '16px',
    opacity: 0.5,
  },
  activeSummaryLogicText: {
    margin: '0px',
    fontSize: '16px',
    opacity: 1,
  },
  bellIconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    marginBottom: 30,
    marginTop: 10,
  },
  bellIcon: {
    width: 56,
    height: 56,
    opacity: 0.5,
    marginTop: 15,
    marginLeft: 5,
  },
  bellIconLabel: {
    fontSize: '16px',
    color: '#494949',
    marginTop: 2,
    marginLeft: -9,
  },
  fieldWithIndicator: {
    width: '100%',
  },
  presentIndicator: {
    width: '100%',
    height: 3,
    marginTop: 4,
    borderRadius: 2,
    backgroundColor: COLOR_PRESENT,
  },
  tardyIndicator: {
    width: '100%',
    height: 3,
    marginTop: 4,
    borderRadius: 2,
    backgroundColor: COLOR_TARDY,
  },
  absentIndicator: {
    width: '100%',
    height: 3,
    marginTop: 4,
    borderRadius: 2,
    backgroundColor: COLOR_ABSENT,
  },
})
